declare const Cookiebot: any

import { COOKIE_OPTIONS } from '@/utils/constants/cookies'

export default defineNuxtPlugin(() => {
  interface IConsent {
    marketing: boolean
    method: string
    necessary: boolean
    preferences: boolean
    stamp: string
    statistics: boolean
  }

  const GDPR_COOKIES = {
    FNC: 'fnc',
    STS: 'sts',
    ADV: 'adv',
    WEB: 'web'
  }

  const gdprCookies = useCookie<string>('gdpr_settings', COOKIE_OPTIONS)

  globalThis.window?.addEventListener(
    'CookiebotOnAccept',
    function () {
      setSelectedGDPRCookies(Cookiebot?.consent)
      useFetchGeolocate()
    },
    false
  )

  globalThis.window?.addEventListener(
    'CookiebotOnDecline',
    function () {
      setSelectedGDPRCookies(Cookiebot?.consent)
      useFetchGeolocate()
    },
    false
  )

  const setSelectedGDPRCookies = (consent: IConsent) => {
    const selectedCookies = [GDPR_COOKIES.FNC]

    if (consent.statistics) {
      selectedCookies.push(GDPR_COOKIES.STS)
    }

    if (consent.marketing) {
      selectedCookies.push(GDPR_COOKIES.ADV)
    }

    if (consent.preferences) {
      selectedCookies.push(GDPR_COOKIES.WEB)
    }

    gdprCookies.value = selectedCookies.join(',')
  }
})
